import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const whatsappNumber = "+91 8838173189"; 

  const toggleWidget = () => {
    setIsOpen(!isOpen);
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent("Hello! I'm interested in learning more about ESN Publications.");
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <div
        onClick={toggleWidget}
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25D366',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
          zIndex: 1000,
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.3)';
        }}
      >
        {isOpen ? (
          <X size={24} color="white" />
        ) : (
          <MessageCircle size={24} color="white" />
        )}
      </div>

      {/* WhatsApp Chat Widget */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            bottom: '100px',
            right: '24px',
            width: '320px',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            zIndex: 999,
            overflow: 'hidden',
            border: '1px solid var(--border-light)'
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: '#25D366',
              color: 'white',
              padding: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}
          >
            <div
              style={{
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <MessageCircle size={20} />
            </div>
            <div>
              <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>
                ESN Publications
              </h4>
              <p style={{ margin: 0, fontSize: '0.8rem', opacity: 0.9 }}>
                Typically replies instantly
              </p>
            </div>
          </div>

          {/* Message */}
          <div style={{ padding: '20px' }}>
            <div
              style={{
                backgroundColor: '#f0f0f0',
                borderRadius: '12px 12px 12px 4px',
                padding: '12px 16px',
                marginBottom: '16px',
                fontSize: '0.9rem',
                lineHeight: 1.4
              }}
            >
              Hi there! 👋<br />
              How can we help you today? Feel free to ask about our publications, conferences, or any other services.
            </div>

            <button
              onClick={openWhatsApp}
              style={{
                width: '100%',
                backgroundColor: '#25D366',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 16px',
                fontSize: '0.95rem',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#128C7E';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#25D366';
              }}
            >
              <MessageCircle size={18} />
              Start Conversation
            </button>
          </div>

          {/* Footer */}
          <div
            style={{
              backgroundColor: '#f8f9fa',
              padding: '12px 20px',
              fontSize: '0.8rem',
              color: '#666',
              textAlign: 'center',
              borderTop: '1px solid var(--border-light)'
            }}
          >
            We're here to help! Chat with us on WhatsApp.
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppWidget;